export const INVOICE_PERIOD = 15;
export const INVOICE_SECOND_PERIOD_START = INVOICE_PERIOD + 1;
export const GET_PERIOD_MIN_PASS_HOUR = 1;

export enum INVOICE_BALANCE_INCOMING_KEYS {
    TOTAL = 'total',
    STRIPE = 'totalStripe',
    CB = 'totalCb',
    CASH = 'totalCash'
}

export const DRIVER_INVOICE_DATE_FORMAT = 'DDMMYYYY';